/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Error_FallbackInputs */

const en_app_error_fallback = /** @type {(inputs: App_Error_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong`)
};

const pt_br2_app_error_fallback = /** @type {(inputs: App_Error_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo deu errado`)
};

/**
* | output |
* | --- |
* | "Something went wrong" |
*
* @param {App_Error_FallbackInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const app_error_fallback = /** @type {((inputs?: App_Error_FallbackInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Error_FallbackInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_app_error_fallback(inputs)
	return pt_br2_app_error_fallback(inputs)
});